<template>
  <RevButton size="medium" variant="secondary" @click="handleConfigureCta">
    {{ i18n(translations.ctaLabel) }}
  </RevButton>
</template>

<script setup lang="ts">
import { useRoute, useRouter } from '#imports'
import { nextTick } from 'vue'

import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'
import {
  Breakpoint,
  getCurrentBreakpoint,
} from '@backmarket/utils/dom/getCurrentBreakpoint'
import { RevButton } from '@ds/components/Button'

import translations from './LpoGoogleShoppingConfigureCta.translations'

const route = useRoute()
const router = useRouter()
const i18n = useI18n()
const { trackClick } = useTracking()

async function handleConfigureCta() {
  trackClick({
    zone: 'pdp_lpo_configure_cta',
    value: 'lpo_configure_cta',
  })

  const {
    utm_source: _utmSource,
    utm_medium: _utmMedium,
    utm_campaign: _utmCampaign,
    ...queryWithoutUtm
  } = route.query

  const navigate = () =>
    router.push({ path: route.path, query: queryWithoutUtm })

  if (document.startViewTransition) {
    await document.startViewTransition(async () => {
      await navigate()
      await nextTick()
    }).finished
  } else {
    await navigate()
    await nextTick()
  }

  const configurator = document.getElementById('configurator')

  if (configurator) {
    const STICKY_BAR_HEIGHT_MOBILE = 49
    const STICKY_BAR_HEIGHT_DESKTOP = 79
    const stickyBarHeight =
      getCurrentBreakpoint() >= Breakpoint.MD
        ? STICKY_BAR_HEIGHT_DESKTOP
        : STICKY_BAR_HEIGHT_MOBILE

    const top = configurator.getBoundingClientRect().top + window.scrollY

    window.scrollTo({ top: top - stickyBarHeight, behavior: 'smooth' })
  }
}
</script>
